// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JJ37q {\n  border: 2px solid var(--color-white);\n  background-color: var(--color-gray-dark);\n  color: var(--color-white) !important;\n  margin-left: -2px;\n}\n\n.gaq0B {\n  border-color: var(--color-white);\n  border-width: 2px;\n  color: var(--color-white);\n  font-family: var(--font-family-base);\n  font-size: 16px;\n}\n\n.gaq0B:hover {\n  background-color: inherit;\n}\n\n.Mi61W:hover {\n  background-color: inherit !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": "JJ37q",
	"chip": "gaq0B",
	"clickable": "Mi61W"
};
export default ___CSS_LOADER_EXPORT___;
